_cachedDocumentCookie